/* Anchors the loading overlay. */
.content {
  position: relative;
}

/* Column widths come from the column defs instead of the rendered content, so paging
   to a page with shorter/longer values cannot move the columns sideways. */
.fixedLayout {
  table-layout: fixed;
}

/* A fixed column can't grow for its content, so long values have to wrap inside it —
   including single unbroken words, which would otherwise overflow the cell. */
.fixedLayout th,
.fixedLayout td {
  overflow-wrap: break-word;
}

/* Header sort toggle */
.sortButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-align: inherit;
  user-select: none;
}

.sortButton:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.sortIcon {
  font-size: var(--font-size-mini);
}

/* Unsorted columns keep the neutral up/down glyph dimmed until hovered. */
.sortIconIdle {
  color: var(--text-muted);
  opacity: 0.6;
}

.sortButton:hover .sortIconIdle {
  opacity: 1;
}

/* Pins the header while the rows scroll in the container. `.table` is forced to
   `border-collapse: collapse`, which drops a stuck cell's own border — so the header
   underline is re-drawn as an inset shadow, and it needs an opaque background to keep
   the rows from showing through it. */
.stickyHeader th {
  position: sticky;
  top: 0;
  /* above cell content that stacks itself — Bootstrap lifts `.input-group` controls to 2,
     and to 3 while focused, which would otherwise scroll over the pinned header */
  z-index: 4;
  background: var(--table-bg);
  box-shadow: inset 0 -2px 0 var(--table-border-color);
}

.stateCell {
  text-align: center;
  color: var(--text-muted);
  padding: 24px 8px;
}

/* Empty rows padding the last page — no hover highlight, not interactive. */
.fillerRow {
  pointer-events: none;
}

/* Translucent veil like the legacy DataTables "processing" panel — keeps the
   rows mounted so the table height doesn't collapse. */
.overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--table-overlay-bg);
  /* above a sticky header, so loading veils the whole table */
  z-index: 5;
}

.overlaySpinner {
  font-size: var(--font-size-base);
  color: var(--color-primary);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: var(--content-padding-small) var(--content-padding-small) var(--content-padding-small) var(--content-padding-large);
}

.pageInfo {
  margin-right: auto;
}

.pageSize {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-muted);
  font-size: var(--font-size-small);
}

/* The theme's `select.input-sm` pairs a fixed height with `line-height: <that height>`.
   Under border-box the line box then overflows the padded content box and the value
   sits off-centre — so let the padding define the height instead. */
.pageSizeSelect {
  display: inline-block;
  width: auto;
  height: auto;
  line-height: var(--line-height-base);
}
